import { Box, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { mobileBreakpoint, useIsMobile, useL10n } from '@uplift/hooks';
import { Button } from '@uplift/ui-v2';


export type AddPaymentMethodProps = {
  onClick?: () => void;
};

export const AddPaymentMethod: React.FC<AddPaymentMethodProps> = ({ onClick }) => {
  const l10n = useL10n();
  const isMobile = useIsMobile(mobileBreakpoint);
  const { classes } = useStyles();

  return (
    <Box display="flex" flexDirection="column" alignItems="flex-start" p={isMobile ? 2 : 4}>
      {!isMobile && (
        <Button variant="contained" color="secondary" onClick={onClick} className={classes.button}>
          {l10n.accountSettings.billing.addPaymentMethod}
        </Button>
      )}
      <Typography variant="body2" color="textSecondary">
        {l10n.accountSettings.billing.afterSessionChargeDescription}
      </Typography>
    </Box>
  );
};

const useStyles = makeStyles()((theme) => ({
  button: {
    marginBottom: theme.spacing(2),
  },
}));
